
import { EErrorType } from '../enum/EErrorType';

export class ToasterModel {
    Message: string | undefined;
    
    Type: EErrorType | undefined
}